import * as React from 'react'

function SvgTiresCheckedIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="m32.293 8.293 1.414 1.414L28 15.414l-3.707-3.707 1.414-1.414L28 12.586l4.293-4.293Z"
        fill="#2EC40B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-6 8a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
        fill="#2EC40B"
      />
      <path
        d="M20 11c0-.686.077-1.355.223-1.998A11.208 11.208 0 0 0 20 9C13.925 9 9 13.925 9 20s4.925 11 11 11 11-4.925 11-11c0-.074 0-.148-.002-.222a9.032 9.032 0 0 1-2.773.19c-.144.175-.23.397-.247.63-.035.47-.11.93-.223 1.374-.057.227.193.426.393.306l.654-.392a8.935 8.935 0 0 1-.743 2.125l-.584.01c-.35.005-.666.196-.863.484-.263.386-.56.748-.885 1.08-.163.168-.046.466.188.462l.763-.013a9.046 9.046 0 0 1-1.704 1.468l-.51-.282a1.079 1.079 0 0 0-.991-.01c-.415.2-.85.365-1.302.492-.226.064-.273.38-.069.494l.667.37a8.969 8.969 0 0 1-2.213.417l-.3-.5c-.18-.3-.504-.479-.853-.505-.47-.034-.93-.11-1.374-.223-.227-.057-.426.193-.306.394l.392.654a8.94 8.94 0 0 1-2.125-.743l-.01-.584a1.078 1.078 0 0 0-.485-.864 8.038 8.038 0 0 1-1.08-.884c-.168-.163-.465-.046-.461.187l.012.764a9.05 9.05 0 0 1-1.468-1.705l.282-.508c.17-.306.164-.677.011-.992-.2-.416-.366-.851-.493-1.303-.063-.225-.38-.273-.493-.068l-.37.667a8.967 8.967 0 0 1-.418-2.213l.5-.3c.3-.18.48-.504.505-.853.035-.47.11-.93.223-1.375.057-.226-.193-.426-.394-.305l-.653.392c.159-.747.41-1.46.742-2.125l.584-.01c.35-.006.667-.197.864-.485.263-.386.56-.748.884-1.08.163-.168.046-.466-.187-.462l-.763.013a9.047 9.047 0 0 1 1.704-1.469l.508.283c.307.17.677.163.993.01.415-.2.85-.366 1.302-.493.225-.063.273-.38.068-.493l-.667-.37a8.97 8.97 0 0 1 2.214-.418l.3.5c.076.126.176.23.294.311A9.101 9.101 0 0 1 20 11Z"
        fill="#000"
      />
      <path
        d="M20 14c.175 0 .349.008.52.023a8.982 8.982 0 0 0 1.312 2.42 4 4 0 1 0 1.725 1.725c.728.554 1.543 1 2.42 1.312A6 6 0 1 1 20 14Z"
        fill="#000"
      />
    </svg>
  )
}

export default SvgTiresCheckedIcon
